<template>
    <v-chip class="ml-1" @click="dialogBeta=true, trackEvent('Beta Clicked', { element: element, feature: feature })" color="primary" text-color="white" small>
      Beta<v-icon dark right small>mdi-creation</v-icon>

      <v-dialog v-model="dialogBeta" width="800" scrollable persistent no-click-animation>
        <v-card>
          <v-card-title class="pa-0">
            <v-toolbar flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium"><v-icon color="primary" left small>mdi-creation</v-icon>Funcionalidad Beta</v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-row align="center" justify="center" class="mr-1">
                  <v-btn class="ml-3" @click="dialogBeta=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
                </v-row>
              </v-toolbar-items>
            </v-toolbar>
          </v-card-title>
          <v-divider />
          <v-card-text class="background">
            <v-row align="center">
              <v-col>
                <span class="my-4 d-block">Estamos diseñado esta funcionalidad con mucho entusiasmo y nos encanta que la estés probando. Queremos que sepas que tu retroalimentación es muy valiosa para nosotros.</span>
                <span class="my-4 d-block">Esta funcionalidad Beta está disponible de forma gratuita mientras la perfeccionamos, pero queremos ser transparentes acerca de nuestros planes futuros.</span>
                <span class="my-4 d-block">En una próxima actualización, esta característica se convertirá en una parte pagada dentro de nuestros planes de suscripción.</span>
                <span class="my-4 d-block">Si disfrutas usando esta funcionalidad y deseas seguirla utilizando en el futuro, asegúrate de estar atento a las actualizaciones y novedades que compartiremos.</span>
                <span class="mt-4 d-block">¡Gracias por ser parte de nuestro viaje en la construcción  de Piriod! Si tienes alguna pregunta o comentario, no dudes en ponerte en contacto con nuestro centro de ayuda.</span>
              </v-col>
              <v-col cols="5">
                <img :src="require(`@/assets/appImage-betaFeature.svg`)" alt="beta feature image" width="100%">
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-chip>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  props: {
    element: {
      type: String,
      required: true
    },
    feature: {
      type: String,
      required: true
    }
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    dialogBeta: false
  })
}
</script>